import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { LazyLoadEvent } from "primeng/api";
import { BaseViewComponent } from 'projects/shared/core/interfaces/baseViewComponent';
import { RmsLoadingService } from 'projects/rms/app/shared/ui-rms/components/loading-spinner/rms-loading.service';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { ToastService } from 'projects/shared/core/services/toast.service';
import { UserService } from 'projects/shared/core/app/api/services/user.service';
import { UserModel } from 'projects/shared/core/app/api/models/user-model';
import { UserSearchComponent } from './user-search/user-search.component';

@Component({
  selector: 'ndms-users-home',
  templateUrl: './users-home.component.html',
  styleUrls: ['./users-home.component.scss']
})
export class UsersHomeComponent extends BaseViewComponent {
  @ViewChild(UserSearchComponent) searchUsers: UserSearchComponent;

  private _users$: BehaviorSubject<UserModel[]> = new BehaviorSubject<UserModel[]>([]);
  get users$() {
    return this._users$.asObservable();
  }
  get users() {
    return this._users$.value;
  }

  private _userApps$: BehaviorSubject<UserModel[]> = new BehaviorSubject<UserModel[]>([]);
  get userApps$() {
    return this._userApps$.asObservable();
  }
  get userApps() {
    return this._userApps$.value;
  }
  
  get isLoading() {
    return this._loadingService.isSectionLoading('UsersHomeComponent');
  }

  get loadingMessage() {
    return this._loadingService.sectionLoadingMessage('UsersHomeComponent');
  }

  first: number = 0;
  count: number = 0;
  displayList: boolean = false;
  searchValues: any = {
    FirstName: "",
    LastName: "",
    UserName: ""
  };
  queryParams: UserService.QueryParams = {
    Page: 1,
    PageSize: 10,
    SortBy: "FullName",
    SortOrder: 1
  };

  constructor( 
    private _ndmsUserService: UserService,
    private _loadingService: RmsLoadingService,
    private _toastService: ToastService,
    private _title: Title,
    lookupService: LookupService) {
    super(lookupService);

    this._title.setTitle("Users - NDMS Suite");
  }

  onClear(clearSearch: boolean) {
    if (clearSearch) {
      this.displayList = false;
      this.searchValues = {};
    }
  }

  onEdit(event) {
    this.getUsers(false);
  }

  onReload(event: LazyLoadEvent) {
    if (!this.displayList) {
      return;
    }
    let sortBy = "";
    switch (event.sortField) {
      case "fullName":
        sortBy = "FullName";
        break;
      case "lastLoggedIn":
        sortBy = "LastLoggedIn";
        break;
      case "userName":
        sortBy = "UserName";
        break;
    }

    this.first = event.first;

    this.queryParams = Object.assign({}, {
      FirstName: this.searchValues.FirstName,
      LastName: this.searchValues.LastName,
      UserName: this.searchValues.UserName,
      Page: this.first / event.rows + 1,
      PageSize: event.rows,
      SortBy: sortBy,
      SortOrder: event.sortOrder,
    });
    this.getUsers(false);
  }

  onSearch(searchValues: any) {
    this.displayList = true;
    this.searchValues = Object.assign({}, searchValues);
    this.queryParams = Object.assign(this.queryParams, this.searchValues);
    this.getUsers(true);
  }

  private getUsers(searching: boolean) {
    let getData = new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._ndmsUserService.Query(this.queryParams), data => {
        this._users$.next(data.model);
        this.count = data.pagingData.totalCount;
        if (searching) {
          this.searchUsers.onSearchComplete();
        }
        return resolve();
      }, error => {
        this._toastService.showError(error);
        reject();
      });
    });

    if (searching) {
      let options = {
        key: 'UsersHomeComponent',
        message: 'Searching...',
        cbPromise: getData
      }
      return this._loadingService.setLoading(options);
    }
  }

  onMainContentClick() {
    let mc = document.querySelector('[main-content]');
    if (mc instanceof HTMLElement) {
      mc.focus();
      mc.blur();
    }
  }
}
